import { useContext, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Table } from "react-bootstrap";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import CustomModal from "../../../helpers/CustomModal/CustomModal";
import EmptyItems from "../../../helpers/EmptyItems/EmptyItems";
import UploadMedia from "../../../helpers/UploadMedia/UploadMedia";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { categoryAdminContext } from "./../../../context/Admin/CategoryAdminContext/CategoryAdminContext";
import { menuImage } from "../../../utils";
import { useSelector } from "react-redux";

const CategoryAdmin = () => {
  const setting = useSelector((state) => state.meta?.setting);

  const {
    categoryId,
    title,
    setTitle,
    image,
    setImage,
    categories,
    isShowModal,
    // Start Category
    showModal,
    closeModal,
    handleCreateCategory,
    handleGetCategories,
    handleEditCategory,
    handleDeleteCategory,
    // End Category
  } = useContext(categoryAdminContext);

  useEffect(() => {
    handleGetCategories();
  }, []);

  return (
    <>
      <SiteTitle title="مدیریت دسته بندی" />

      <div className="container-fluid mt-4">
        <button
          type="button"
          className="kf-btn mb-3"
          onClick={() => showModal(null)}
        >
          <span>افزودن دسته بندی</span>
        </button>

        {isEmpty(categories) ? (
          <EmptyItems />
        ) : (
          <div className="card">
            <Table responsive hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>تصویر</th>
                  <th>عنوان دسته بندی</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {categories.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={menuImage(item.image, setting.logo)}
                        style={{ width: 50, height: 50 }}
                        alt={item.title}
                      />
                    </td>
                    <td>{item.title}</td>
                    <td>
                      <SubCategoryAdmin category={item} />

                      <button
                        type="button"
                        className="btn-primary mx-2"
                        onClick={() => showModal(item)}
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        className="btn-danger mx-2"
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteCategory(item._id),
                            `آیا از حذف ${item.title} مطمئنید؟`,
                          )
                        }
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      {/* Start Add OR Edit Modal */}
      <CustomModal
        size="lg"
        title={`${categoryId ? "ویرایش" : "افزودن"} دسته بندی`}
        show={isShowModal}
        onHide={closeModal}
      >
        <form onSubmit={categoryId ? handleEditCategory : handleCreateCategory}>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setImage(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field">
                    <input
                      type="text"
                      name="image"
                      placeholder="تصویر"
                      onChange={(e) => setImage(e.target.value)}
                      value={image}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="kf-field">
                <input
                  type="text"
                  name="title"
                  placeholder="عنوان"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
                <i className="la la-file" />
              </div>
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>{categoryId ? "ویرایش" : "اضافه"}</span>
            </button>
            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={closeModal}
            >
              انصراف
            </button>
          </div>
        </form>
      </CustomModal>
      {/* End Add OR Edit Modal */}
    </>
  );
};

export default CategoryAdmin;

const SubCategoryAdmin = ({ category }) => {
  const setting = useSelector((state) => state.meta?.setting);

  const [subCategoryId, setSubCategoryId] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);

  const {
    setCategoryId,
    image,
    setImage,
    title,
    setTitle,
    subCategories,
    setSubCategories,
    handleCreateSubCategory,
    handleGetSubCategories,
    handleEditSubCategory,
    handleDeleteSubCategory,
  } = useContext(categoryAdminContext);

  const resetStates = () => {
    setSubCategoryId("");
    setTitle("");
    setImage("");
  };

  const showModal = () => {
    setIsOpenModal(true);
    setCategoryId(category._id);
  };

  const closeModal = () => {
    setIsOpenModal(false);

    resetStates();
    setCategoryId("");
    setSubCategories([]);
  };

  return (
    <>
      {/* Start Sub Category */}
      <button
        type="button"
        className="admin-btn bg-dark"
        onClick={() => handleGetSubCategories(category._id, showModal)}
      >
        زیر دسته ها
      </button>
      <CustomModal
        size="lg"
        title={`زیر دسته های ${category.title}`}
        show={isOpenModal}
        onHide={closeModal}
      >
        <form
          className="mb-3"
          onSubmit={(event) =>
            subCategoryId
              ? handleEditSubCategory(event, subCategoryId, resetStates)
              : handleCreateSubCategory(event, resetStates)
          }
        >
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3">
                  <UploadMedia callback={(val) => setImage(val)} />
                </div>
                <div className="col-12 col-md-6 col-lg-9">
                  <div className="kf-field">
                    <input
                      type="text"
                      name="image"
                      placeholder="تصویر"
                      onChange={(e) => setImage(e.target.value)}
                      value={image}
                    />
                    <i className="la la-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="kf-field">
                <input
                  type="text"
                  name="title"
                  placeholder="عنوان"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
                <i className="la la-file" />
              </div>
            </div>
          </div>

          <div className="kf-bts mt-4">
            <button className="kf-btn" type="submit">
              <span>{subCategoryId ? "ویرایش" : "اضافه"}</span>
            </button>

            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={closeModal}
            >
              انصراف
            </button>
          </div>
        </form>

        {isEmpty(subCategories) ? (
          <EmptyItems />
        ) : (
          <div className="card">
            <Table responsive hover>
              <thead className="bg-light">
                <tr>
                  <th>#</th>
                  <th>تصویر</th>
                  <th>نام دسته</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {/* 1 */}
                {subCategories.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={menuImage(item.image, setting.logo)}
                        style={{ width: 50, height: 50 }}
                        alt={item.title}
                      />
                    </td>
                    <td>{item.title}</td>
                    <td>
                      <button
                        type="button"
                        className="btn-primary mx-2"
                        onClick={() => {
                          setImage(item.image);
                          setTitle(item.title);
                          setSubCategoryId(item._id);
                        }}
                      >
                        ویرایش
                      </button>
                      <button
                        type="button"
                        className="btn-danger mx-2"
                        onClick={() =>
                          areYouSureMessage(
                            () =>
                              handleDeleteSubCategory(item._id, category._id),
                            `آیا از حذف ${item.title} مطمئنید؟`,
                          )
                        }
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </CustomModal>
      {/* End Sub Category */}
    </>
  );
};
